import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Research Methods Teacher | New York, USA',
  text: 'The research design module completely changed how my students see methodology. They finally understand the differences without getting confused. It is the clearest resource I have ever found for this topic. I use it from the very first class and it hooks them immediately.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'High School Educator | Melbourne, Australia',
  text: 'The assessment pack is worth the price of the entire bundle on its own. I have not built an exam from scratch under pressure in months. I end every term knowing everything is already solved.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Research Methods Instructor | Toronto, Canada',
  text: 'The visual process map transformed my most difficult class. I project it at the start of every lesson and my students always know exactly where they are in the research process. I have not found that in any other resource.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'High School Teacher | London, UK',
  text: 'The glossary gave me my class time back. Before this I was losing the first twenty minutes of every lesson defining terms. Now students arrive having read the glossary and we go straight into the content.'
}, {
  initials: 'SR',
  name: 'Sebastian R.',
  role: 'Research Methods Educator | Dublin, Ireland',
  text: 'The activity pack was a revelation. My students were finally engaged with methodology in a way I had never seen before. Every worksheet is exactly what a high school classroom needs.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-67">
            What teachers who already have their pack are saying:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69">
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-70" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-73">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-75">
                  {t.initials}
                </div>
                <div data-id="element-76">
                  <div className="font-bold text-white" data-id="element-77">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-78">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}